import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MobileWebViewService} from '@mpt-fo/common/core/services/mobile-web-view.service';
import {OnboardingService} from '@mpt-fo/common/core/services/onboarding.service';
import { DialogMessageType } from "@mpt-fo/common/shared/models/utility.model";
import { DelegateType } from '@mpt-fo/common/shared/models/utility.model';
import {ModalOptionsConfig, ModalService} from '@mpt-fo/common/lean-shared/components/nz-modal-service/modal.service';
import {NzModalRef} from 'ng-zorro-antd/modal';
import {StringHelper} from '@mpt-fo/common/core/helpers/strings.helper';
import {CountdownType} from '@mpt-fo/common/kamona/components/otp-count-down/otp-count-down.component';
import {KamonaLayoutHeightUnit, WizardNavigation} from '@mpt-fo/common/kamona/model/kamonal-model';
import {ModalHelperService} from '@mpt-fo/common/core/services/modal-helper.service';
import {MobileDelegateService} from '@mpt-fo/common/core/services/mobile-delegate.service';
import {
	DEFAULT_DIALOG_CLASSES,
	DEFAULT_FAILED_OTP_MODAL_WIDTH,
	DEFAULT_MODAL_KAMONA_CLASSES,
	DEFAULT_MODAL_WIDTH,
	MONIEPOINT_DESIGN_TYPE
} from '@mpt-fo/common/shared/constants';
import {MessageType} from '@mpt-fo/common/shared/models/utility.model';
import {UtilityService} from '@mpt-fo/common/core/services/utility.service';
import {ScreenManagerService} from '@mpt-fo/common/core/services/screen-manager.service';
import {Router} from '@angular/router';
import {KycService} from '@mpt-fo/common/core/services/kyc-service';
import {
	PasswordInput,
	PasswordValidatorType
} from '@mpt-fo/common/kamona/components/kamona-input-field/kamona-input-field.component';
import {FormBuilder, FormGroup} from '@angular/forms';
import {BusinessService} from '@mpt-fo/common/core/services/business.service';
import {LocalStorageService} from '@mpt-fo/common/core/services/local-storage.service';
import {StorageKeys} from '@mpt-fo/common/shared/models/storage-keys';
import {ProfileService} from '@mpt-fo/common/core/services/profile.service';
import {AppConfig} from '@mpt-fo/common/shared/config/app-config';

@Component({
	selector: 'app-otp-pin-creation',
	templateUrl: './otp-pin-creation.component.html',
	styleUrls: ['./otp-pin-creation.component.scss'],
})
export class OtpPinCreationComponent implements OnInit {

	@Output() proceed = new EventEmitter();
	@Output() previous = new EventEmitter();
	@Output() emitMessage = new EventEmitter();
	@Output() otpMessage = new EventEmitter();
	@Input() otpData: any;
	pin: string;
	ussdCode: any;
	submitting: boolean;
	loading = true;
	isDisable: boolean;
	readonly TotalLengthOfPin = 6;
	suspensionReleaseTime: any;
	otpErrorMessage: string;
	runningModal: NzModalRef;
	mobileNumber: string;
	validationKey: any;
	errorMessage: string;
	isSuspensionOver = true;
	messageType: MessageType;
	countdownType: CountdownType = CountdownType.KAMONA;
	isMobile: boolean;
	showSuccess: boolean;
	messageDialogType: DialogMessageType;
	mobileModalTitle: string;
	mobileModalDesc: string;
	transactionPin = null;
	otp: PasswordInput;
	form: FormGroup;
	heightUnit = KamonaLayoutHeightUnit;
	readonly TRANSACTION_PIN_LENGTH = 6;
	otpFormData: any;

	constructor(
		private mobileService: MobileWebViewService,
		private onboardingService: OnboardingService,
		private modalService: ModalService,
		private modalHelper: ModalHelperService,
		private delegateService: MobileDelegateService,
		private utilityService: UtilityService,
		private screenManagerService: ScreenManagerService,
		private router: Router,
		private kycService: KycService,
		private fb: FormBuilder,
		private businessService: BusinessService,
		private localStorage: LocalStorageService,
		private profileService: ProfileService,
		private config: AppConfig) {
	}

	ngOnInit(): void {
		const formData = this.businessService.otpFormData;
		if (!formData?.password || !formData.newPin) {
			this.businessService.resetRoute();
			this.router.navigateByUrl('pin/business-pin');
		}

		this.isMobile = this.screenManagerService.isMobile();
		this.screenManagerService.isMobile$.subscribe(isMobile => {
			this.isMobile = isMobile;
		});
	}

	handleError(err) {
		const isSuspended = err?.error?.code === '400208' || err?.error?.code === '400209';
		if (isSuspended) {
			const otpErrorMessage = err?.error?.responseMessage || err?.error?.description;
			const suspensionReleaseTime = err?.error?.suspensionReleaseTime;
			this.otpErrorMessage = otpErrorMessage;
			this.launchFullAlertModal({
				title: 'You’ve been suspended',
				description: otpErrorMessage,
				callbackName: 'Retry',
				expiryTime: new Date(`${suspensionReleaseTime}`).getTime(),
			});
		} else {
			this.messageType = MessageType.RETRY;
			const description = err.error?.description || StringHelper.getErrorMessageHttpErrorResponse(err);
			const title = 'OTP Failed To Generate';
			this.launchAlertModal({
				title,
				description,
				callbackName: 'Try Again'
			});
		}
	}

	launchAlertModal(params) {
		const config = new ModalOptionsConfig();
		config.nzComponentParams.alertType = 'error';
		config.nzComponentParams.title = 'Request failed';
		config.className = DEFAULT_MODAL_KAMONA_CLASSES;
		config.nzWidth = DEFAULT_MODAL_WIDTH;
		config.nzComponentParams.designType = MONIEPOINT_DESIGN_TYPE.KAMONA;
		config.nzComponentParams.callbackName = params?.callbackName || 'Close';
		config.nzComponentParams.message = params?.description;
		this.runningModal = this.modalService.alert(config);
	}

	launchFullAlertModal(params) {
		const config = new ModalOptionsConfig();
		config.nzComponentParams.alertType = params?.alertType || 'error';
		config.nzComponentParams.title = params?.title || 'Request failed';
		config.className = DEFAULT_DIALOG_CLASSES;
		config.nzWidth = DEFAULT_FAILED_OTP_MODAL_WIDTH;
		if (params?.alertType === 'success') {
			config.nzComponentParams.canShowLoading = true;
			config.nzComponentParams.callback = () => {
				this.handleOncloseModal();
			};
		}
		config.nzComponentParams.designType = MONIEPOINT_DESIGN_TYPE.KAMONA;
		config.nzComponentParams.expiryTime = params?.expiryTime;
		config.nzComponentParams.callbackName = params?.callbackName || 'Close';
		config.nzComponentParams.message = params?.description;
		config.nzComponentParams.extraMessage = params?.extraMessage;
		this.runningModal = this.modalService.newalert(config);
	}

	handleOncloseModal() {
		this.router.navigate(['main-app', 'business-user', 'dashboard'])
			.then(() => {
				this.clearData();
				this.closeModal();
			}).catch(error => {
			this.clearData();
			this.closeModal();
			this.router.navigate(['main-app', 'business-user', 'dashboard']);
		});
	}

	clearData() {
		const otpFormData = {
			password: '',
			newPin: '',
			pinResetOTP: '',
			currentRoute: null
		};
		this.businessService.saveData(otpFormData);
	}

	closeModal() {
		try {
			this.runningModal.destroy();
		} catch (error) {
		}
	}

	async initialize() {
		this.otpFormData = this.businessService.otpFormData;
		this.otp = new PasswordInput(null, 'Enter OTP', true, PasswordValidatorType.PIN, this.TRANSACTION_PIN_LENGTH);
		this.otp.showPasswordHint = false;
		this.otp.setCanShowError(false);
		this.form = this.fb.group({
			otp: this.otp.getFormGroupControl()
		});
		let businessPhone = this.localStorage.get(StorageKeys.businessNumber);
		businessPhone = businessPhone?.slice(3);
		businessPhone = '0' + businessPhone;
		this.mobileNumber = businessPhone;
		await this.initiateOTP();
	}

	async initiateOTP() {
		const formData = this.businessService.getData();
		const password = formData?.password;
		const params = {password};
		const otpData = await this.profileService.initialResetPin(params);
		this.ussdCode = otpData?.ussdCode;
	}

	next() {
		if (this.submitting) {
			return;
		}
		this.submitting = true;
		const form = this.form?.value;
		const pinResetOTP = form?.otp || this.pin;
		const data = {
			password: this.otpFormData?.password,
			newPin: this.otpFormData?.newPin,
			pinResetOTP
		};
		this.kycService.setBusinessTransactionPin(data)
			.then(() => {
				if (this.config.SET_DEFAULT_NOTIFICATION_PREFERENCE) {
					this.getNotificationPreference();
				}
				this.launchFullAlertModal({
					title: 'PIN Set Successfully',
					description: 'You can change your PIN on the Business Information tab on the menu',
					alertType: 'success',
					callbackName: 'Continue to Dashboard',
					extraMessage: 'You can change your PIN on the Business Information tab on the menu'
				});
				this.submitting = false;
			})
			.catch(err => {
				const isSuspended = err?.error?.code === '400208' || err?.error?.code === '400209';
				const description = isSuspended ? err?.error?.responseMessage : StringHelper.getErrorMessageHttpErrorResponse(err);
				const title = 'Request Failed';
				this.messageType = MessageType.RETRY;
				this.launchAlertModal({
					title,
					description
				});
				this.submitting = false;
			});
	}

	setPin($event: string) {
		this.pin = $event;
		this.isDisable = ($event.length || this.form?.value?.otp?.length) === this.TotalLengthOfPin;
		this.isDisable = this.errorMessage ? false : this.isDisable;
	}

	listenForOtp() {
		this.delegateService.getDelegateData(DelegateType.listenForOtp)
			.then(res => {
			})
			.catch(error => {
				console.log('Error calling listenForOtp delegate ', error);
			});
	}

	retryOtp() {
		this.loading = false;
		this.initiateOTP()
			.then(() => {
				this.loading = false;
			})
			.catch(error => {
				this.handleError(error);
				this.loading = false;
			});
	}


	previousStep() {
		if (!this.submitting) {
			this.onboardingService.setSignupData(null, WizardNavigation.PREVIOUS);
		}
	}

	goBack() {
		if (this.submitting) {
			return;
		}
		const routes = this.businessService.getKycRoutes();
		const currentRoute = this.businessService.getData();
		const route = routes.find(x => x.route === currentRoute?.currentRoute?.previousUrl);
		if (route) {
			route.completed = false;
			this.businessService.navigateKYCForm(route);
		} else {
			this.businessService.resetRoute();
			this.router.navigateByUrl('user/selection-mode');
		}
	}

	callDialer(code: string) {
		if (this.mobileService.isMobileWebViewUser()) {
			try {
				this.delegateService
					.setDelegateData(DelegateType.launchDialer, code)
					.then((res) => {
					})
					.catch((error) => {
						console.log('error from launchDialer', error);
					});
			} catch (error) {
				console.log('error from launchDialer', error);
			}
		}
	}

	getNotificationPreference() {
		//getting called after Business Pin is successfully created
		this.businessService.getNotificationPreference().then((res) => {
		}).catch((err) => {
		})
	}
}
